// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"430cf6fb","4174":"430cf6fb","6301":"430cf6fb","9340":"430cf6fb","9435":"430cf6fb"}[chunkId] + ".chunk.css";
};